export class PoliticaSenha {
    id : number;
    organizacaoId : number;
    regex : string;
    descricao : string;
}